import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../mock/data';
import { useReveal } from '../hooks/useReveal';

function Card({ t, index }) {
  const { ref, inView } = useReveal();
  return (
    <div
      ref={ref}
      style={{ transitionDelay: `${(index % 2) * 120}ms` }}
      className={`reveal ${inView ? 'in-view' : ''} lift rounded-2xl bg-white border border-[var(--pca-border)] p-7 relative`}
    >
      <Quote className="absolute top-6 right-6 text-blue-100" size={40} />
      <div className="flex items-center gap-1 text-yellow-400">
        {['s1', 's2', 's3', 's4', 's5'].map((sid) => <Star key={sid} size={14} fill="currentColor" />)}
      </div>
      <p className="mt-4 text-slate-700 leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
      <div className="mt-6 flex items-center gap-3">
        <div className="w-11 h-11 rounded-full bg-[#0B2E6E] text-white font-bold flex items-center justify-center">{t.initials}</div>
        <div>
          <div className="font-bold text-[#0B2E6E]">{t.name}</div>
          <div className="text-sm text-slate-500">{t.role} · {t.company}</div>
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const { ref, inView } = useReveal();
  return (
    <section className="py-20 md:py-28 bg-[var(--pca-blue-tint)]">
      <div className="container-x">
        <div ref={ref} className={`reveal ${inView ? 'in-view' : ''} text-center max-w-2xl mx-auto`}>
          <span className="section-eyebrow">VOICES OF PCA</span>
          <h2 className="section-title mt-4 text-[34px] md:text-[44px] leading-tight">What our community says</h2>
          <p className="mt-4 text-slate-600">Real stories from our students, alumni, and parents about their PCA experience.</p>
        </div>

        <div className="mt-12 grid gap-5 md:grid-cols-2">
          {testimonials.map((t, i) => <Card key={t.id} t={t} index={i} />)}
        </div>
      </div>
    </section>
  );
}
